<div class="min-h-screen flex">
  <!-- LEFT: Login -->
  <div class="flex flex-col items-center justify-center w-full md:w-1/2 p-8">
    <img src="/assets/logo/logo-name.svg" alt="" class="absolute left-0 top-0 p-6 max-w-96">
    <div class="w-full max-w-md p-8 space-y-8 ">
      <div class="text-left">
        <h1 class="text-2xl font-bold text-gray-900">Bentornato su Keyconnect</h1>
        <p class="mt-2 text-sm text-gray-600">
          Accedi al tuo account
        </p>
      </div>

      <form [formGroup]="loginForm" class="mt-8 space-y-6" (submit)="onSubmit()">
        <div class="space-y-4">
          <!-- Email -->
          <p-float-label variant="on">
            <label class="block text-sm font-medium mb-1">Email</label>
            <input
              pInputText
              formControlName="email"
              class="w-full"
              type="email"
              autocomplete="email"
            />
          </p-float-label>
          <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="text-red-500 text-sm mt-1">
            <span *ngIf="loginForm.get('email')?.errors?.['required']">Email obbligatoria</span>
            <span *ngIf="loginForm.get('email')?.errors?.['email']">Per favore inserisci un'email valida.</span>
          </div>

          <!-- Password -->
          <p-float-label variant="on">
            <label class="block text-sm font-medium mb-1">Password</label>
            <input
              pInputText
              formControlName="password"
              class="w-full"
              type="password"
              autocomplete="current-password"
            />
          </p-float-label>
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="text-red-500 text-sm mt-1">
            <span *ngIf="loginForm.get('password')?.errors?.['required']">Password obbligatoria</span>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-center">
          <p-button
            label="Login"
            icon="pi pi-sign-in"
            [loading]="isLoading"
            [disabled]="loginForm.invalid || isLoading"
            type="submit"
            styleClass="w-full"
            class="w-full"
          ></p-button>
        </div>
      </form>
    </div>
  </div>

  <!-- RIGHT: Image -->
  <div
    class="md:block bg-contain bg-no-repeat bg-center h-auto w-1/2 m-5 rounded-4xl"
    style="background-image: url('/assets/layout/login-cover.svg');"
  ></div>
</div>
